import React from 'react';
import styles from './Clients.module.css';
import varsha from '../../../Assets/Home/varsha.png';
import manisha from '../../../Assets/Home/Manisha.jpg';
import chate from '../../../Assets/Home/Chate.jpg';

const reviews = [
  {
    text: "My association with Lalit sir the founder of Yeskondo goes a long way. It has been almost 8 years we are associated and to be true they as a team are amazing. Their ideas, strategies and suggestions have really worked for my Preschool. All the best 🙏",
    name: 'Manisha Bhawar',
    role: 'Director, Jump Thru Joy Preschool',
    image: manisha,
    rating: 5,
  },
  {
    text: "Our experience with the team's advertising service for our school was exceptional. Their professionalism, creativity, and attention to detail exceeded our expectations. Highly satisfied and would strongly recommend your services to others.",
    name: 'Varsha Phukane',
    role: 'Principal, Hillgreen Highschool & Jr College',
    image: varsha,
    rating: 5,
  },
  {
    text: "This team works very effectively — they study how marketing is done and deliver the message to the public through different mediums. Lalit studies it properly and gives 100% quality results. Salut Lalit & your team!",
    name: 'Prof. Fulchand Chate',
    role: 'Founder, Chate Public School',
    image: chate,
    rating: 5,
  },
];

const Stars = ({ count }) => (
  <div className={styles.stars}>
    {'★'.repeat(count)}
  </div>
);

const Clients = () => {
  return (
    <section className={styles.clients} aria-label="Client Testimonials — Yeskondo Media Pune">
      <div className={styles.container}>

        {/* Section Header */}
        <div className={styles.section_header}>
          <span className={styles.eyebrow}>Client Stories</span>
          <h2 className={styles.section_title}>
            Trusted by Businesses <span>Across Pune</span>
          </h2>
          <p className={styles.section_desc}>
            Don't just take our word for it — here's what clients say about working
            with Yeskondo Media, Pune's best marketing company.
          </p>
        </div>

        {/* Reviews Grid */}
        <div className={styles.reviews_grid}>
          {reviews.map((r, i) => (
            <div key={i} className={styles.review_card}>
              <div className={styles.quote_icon}>"</div>
              <Stars count={r.rating} />
              <p className={styles.review_text}>{r.text}</p>
              <div className={styles.reviewer}>
                <img
                  src={r.image}
                  alt={`${r.name} — Client of Yeskondo Media Pune`}
                  className={styles.reviewer_img}
                  loading="lazy"
                />
                <div>
                  <div className={styles.reviewer_name}>{r.name}</div>
                  <div className={styles.reviewer_role}>{r.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Rating badge */}
        <div className={styles.rating_badge}>
          <span className={styles.badge_stars}>★★★★★</span>
          <span className={styles.badge_text}>5.0 Rating on Google</span>
          <span className={styles.badge_sep}>|</span>
          <span className={styles.badge_text}>267+ Happy Clients</span>
        </div>

      </div>
    </section>
  );
};

export default Clients;
